module.exports = __webpack_public_path__ + "img/travel-front-clay.9f04f08b.png";